import type { TimelineItem } from "../types/content";

export const experience: TimelineItem[] = [
  {
    title: "Web & AI Developer",
    organization: "PwC",
    location: "Avenue de Telfair, Moka, Mauritius",
    dates: "July 2024 — October 2024",
    type: "Full time",
    description:
      "Contributed to web and AI-oriented development, including payroll-platform work, Workday integration, SQL solutions and the exploration of machine-learning capabilities.",
    areas: ["Web development", "SQL", "Workday integration", "Applied AI"],
  },
  {
    title: "Oracle SQL Developer",
    organization: "Spoon Consulting",
    location: "Moka Vivea Business Park, Mauritius",
    dates: "June 2023 — August 2023",
    type: "Internship",
    description:
      "Supported a legacy-data migration from Oracle 7 to Oracle 12 through SQL development, data testing, migration validation and technical documentation.",
    areas: ["Oracle SQL", "Data migration", "Testing", "Documentation"],
  },
  {
    title: "Web Developer",
    organization: "Dayforce, formerly Ceridian",
    location: "Ebene, Mauritius",
    dates: "April 2023 — June 2023",
    type: "Internship",
    description:
      "Contributed to a React-based web application using ASP.NET, C# and the MVC framework within an Agile development environment.",
    areas: ["React", "ASP.NET", "C#", "MVC", "Agile"],
  },
];
